import Vue from "vue";
import Vuex from "vuex";
import tab from "./tab";
import pickDrum from "./pickDrum";
import user from "./user";
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    tab,
    pickDrum,
    user,
  },
});
